import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  resize: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

const FilePreviewComponent = ({ type, url }) => {
  const classes = useStyles();
  if (url !== "") {
    if (type === "audio") {
      return (
        <audio src={url} controls>
          Your browser does not support the audio tag.
        </audio>
      );
    } else if (type === "video") {
      return (
        <video src={url} width="100%" height="100%" controls>
          Your browser does not support the video tag.
        </video>
      );
    } else if (type === "pdf") {
      return (
        <iframe src={url} title="Uploaded file" width="100%" height="500vh">
          This browser does not support PDFs.
        </iframe>
      );
    } else if (type === "image") {
      return (
        <img
          src={url}
          alt={"image cant be loaded, open it at " + url}
          className={classes.resize}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default FilePreviewComponent;
